import { useMemo, useRef } from "react";
import { FmSelectionActionsProps } from "domains/file-manager/components/FileManagerV2/FmSelectionActions";
import { FmFileCanvas } from "domains/file-manager/interfacesV2";
import { useTeamContext } from "domains/teams/contexts/TeamProvider";

import SelectionActionDelete from "./SelectionActionDelete";
import SelectionActionDuplicate from "./SelectionActionDuplicate";

export type SelectionActionsCustomProps = {
  isDeleting: boolean;
  onDeleteClick: (files: FmFileCanvas[]) => void;
};

export type SelectionActionsProps = FmSelectionActionsProps<
  "canvas",
  SelectionActionsCustomProps
>;

export default function SelectionActions({
  selectedFiles,
  isDisplayed = false,
  isDeleting = false,
  onDeleteClick,
}: SelectionActionsProps) {
  const { selectedProject } = useTeamContext();
  const buttonDeleteRef = useRef<HTMLButtonElement>(null);

  const isLoading = isDeleting;

  const isRemovable = useMemo(
    () =>
      !selectedFiles.find((file) => file.meta.ownerId !== selectedProject.id),
    [selectedFiles, selectedProject.id]
  );

  return (
    <>
      <SelectionActionDelete
        selectedFiles={selectedFiles}
        isDisplayed={isDisplayed}
        isDisabled={isLoading || !isRemovable}
        errorMessage={!isRemovable ? "One item cannot be deleted." : undefined}
        isLoading={isDeleting}
        buttonRef={buttonDeleteRef}
        onClick={onDeleteClick}
      />

      <SelectionActionDuplicate
        selectedFiles={selectedFiles}
        isDisplayed={isDisplayed}
      />
    </>
  );
}
